import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const login = r =>
  require.ensure([], () => r(require("@/page/login")), "login");
const manage = r =>
  require.ensure([], () => r(require("@/page/manage")), "manage");
const user = r => require.ensure([], () => r(require("@/page/user")), "user");
const order = r =>
  require.ensure([], () => r(require("@/page/order")), "order");
const notice = r =>
  require.ensure([], () => r(require("@/page/notice")), "notice");
const newnotice = r =>
  require.ensure([], () => r(require("@/page/newnotice")), "newnotice");
const server = r =>
  require.ensure([], () => r(require("@/page/server")), "server");
const pay = r => require.ensure([], () => r(require("@/page/pay")), "pay");
const service = r =>
  require.ensure([], () => r(require("@/page/service")), "service");
const servicelogo = r =>
  require.ensure([], () => r(require("@/page/servicelogo")), "servicelogo");

const comparison = r =>
  require.ensure([], () => r(require("@/page/comparison")), "comparison");
const Filtering = r => require.ensure([], () => r(require("@/page/Filtering")), "Filtering");
const allocation = r => require.ensure([], () => r(require("@/page/allocation")), "allocation");
const test = r => require.ensure([], () => r(require("@/page/test")), "test");

const testPriceManage = r => require.ensure([], () => r(require("@/page/testPriceManage")), "testPriceManage");
const testAreaManage = r => require.ensure([], () => r(require("@/page/testAreaManage")), "testAreaManage");
const testDeviceManage = r => require.ensure([], () => r(require("@/page/testDeviceManage")), "testDeviceManage");

const phoneAreaManage = r => require.ensure([], () => r(require("@/page/phoneAreaManage")), "phoneAreaManage");

const performance = r =>
  require.ensure([], () => r(require("@/page/performance")), "performance");
const search = r =>
  require.ensure([], () => r(require("@/page/search")), "search");
const authority = r =>
  require.ensure([], () => r(require("@/page/authority")), "authority");
const adminList = r =>
  require.ensure([], () => r(require("@/page/adminList")), "adminList");
const adminSet = r =>
  require.ensure([], () => r(require("@/page/adminSet")), "adminSet");
const picture = r =>
  require.ensure([], () => r(require("@/page/picture")), "picture");
const searchorder = r =>
  require.ensure([], () => r(require("@/page/searchorder")), "searchorder");



const logo = r =>
  require.ensure([], () => r(require("@/page/logo")), "logo");
const routes = [
  {
    path: "/",
    component: login
    // component: manage,
  },
  {
    path: "/manage",
    component: manage,
    name: "",
    children: [
      {
        path: "",
        component: user,
        meta: []
      },
      {
        path: "/user",
        component: user,
        meta: []
      },
      {
        path: "/order",
        component: order,
        meta: []
      },
      {
        path: "/picture",
        component: picture,
        meta: []
      },
      {
        path: "/testPriceManage",
        component: testPriceManage,
        meta: []
      },
      {
        path: "/test",
        component: test,
        meta: []
      },
      {
        path: "/testDeviceManage",
        component: testDeviceManage,
        meta: []
      },
      {
        path: '/testAreaManage', 
        component: testAreaManage,
        meta: [],
      },
      
      {
        path: "/adminList",
        component: adminList,
        meta: ["数据管理", "管理员列表"]
      },
      {
        path: "/comparison",
        component: comparison,
        meta: []
      },
      {
        path: "/Filtering",
        component: Filtering,
        meta: []
      },
      {
        path: '/allocation', 
        component: allocation,
        meta: [],
      },
      {
        path: "/notice",
        component: notice,
        meta: []
      },
      {
        path: "/performance",
        component: performance,
        meta: []
      },
      {
        path: "/search",
        component: search,
        meta: []
      },
      {
        path: "/searchorder",
        component: searchorder,
        meta: []
      },
      
      {
        path: "/newnotice",
        component: newnotice,
        meta: []
      },
      {
        path: "/server",
        component: server,
        meta: []
      },
      {
        path: "/pay",
        component: pay,
        meta: []
      },
      {
        path: "/adminSet",
        component: adminSet,
        meta: ["设置", "管理员设置"]
      },
      {
        path: "/service",
        component: service,
        meta: []
      },
      {
        path: "/servicelogo",
        component: servicelogo,
        meta: []
      },
      {
        path: "/phoneAreaManage",
        component: phoneAreaManage,
        meta: []
      },
      {
        path: "/authority",
        component: authority,
        meta: []
      },
      {
        path: "/logo",
        component: logo,
        meta: []
      }
    ]
  }
];

// // 导航守卫
// // 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
// routes.beforeEach((to, from, next) => {
//   if (to.path === '/') {
//     next();
//   } else {
//     let token = localStorage.getItem('Authorization');

//     if (token === null || token === '') {
//       next('/');
//     } else {
//       next();
//     }
//   }
// });

export default new Router({
  routes,
  strict: process.env.NODE_ENV !== "production"
});



// WEBPACK FOOTER //
// ./src/router/index.js